<template>
  <div class="subsector ozonedepleting">
    <div class="parent-sector">
      <p>Industrial Processes</p>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-6">
          <h1>Substitutes for Ozone-Depleting Substances</h1>
          <div class="row">
            <div class="col-sm">
              <p>
                HFCs are used as alternatives to several classes of ODSs that
                are being phased out under the terms of the Montreal Protocol.
                ODSs, which include chlorofluorocarbons (CFCs), halons, carbon
                tetrachloride, methyl chloroform, and HCFCs, have been used in a
                variety of industrial applications, including refrigeration and
                air-conditioning equipment (ref/AC), aerosols, solvent cleaning,
                fire extinguishing, foam production, and sterilization. HFCs are
                not harmful to the stratospheric ozone layer, but they are
                powerful GHGs.
              </p>
              <p>
                Through 2030, emissions and consumption of HFCs are expected to
                grow in both developed and developing countries but will grow
                much more quickly in developing countries. . In contrast to
                developing countries where emission increases are driven by
                growth in the amount of equipment used, emission increases in
                developed countries are driven primarily by the aging and
                replacement of existing ODS equipment.
              </p>
              <p>
                Abatement of HFC emissions from this collection of sources is
                challenging given the available technology. This analysis
                estimates that available abatement technologies can only abate
                approximately 1% of emissions from fire protection and
                foam-related emissions. Abatement potential in emissions from
                solvent use rises to 9%. Abatement potential in emissions from
                aerosols is 48% of aerosol-related emissions because of readily
                available ways to remove aerosols from consumer products.
              </p>
              <p>
                Emissions from ref/AC contribute to 90% of baseline emissions
                from the ODS substitutes category and are also the largest
                source of potential abatement. Abatement measures targeting
                ref/AC emissions have the potential to abate 515 MtCO₂e of
                emissions, which represents 39% of baseline ref/AC emissions.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <p class="center">
            <button
              @click="
                switchComponent('ChartOzone1');
                activate(1);
              "
              :class="{ active: active_el == 1 }"
            >Projected Emissions</button>
            <button
              @click="
                switchComponent('ChartOzone2');
                activate(2);
              "
              :class="{ active: active_el == 2 }"
            >Reduction Potential</button>
          </p>

          <div class="container">
            <component v-bind:is="currentComp"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartOzone1 from "@/components/industrialprocesses/ChartOzone1";
import ChartOzone2 from "@/components/industrialprocesses/ChartOzone2";

export default {
  components: {
    ChartOzone1,
    ChartOzone2
  },
  data() {
    return {
      currentComp: "ChartOzone1",
      active_el: 1
    };
  },
  methods: {
    switchComponent(comp) {
      //alert("test comp: " + comp);
      return (this.currentComp = comp);
    },
    activate: function(el) {
      this.active_el = el;
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: normal;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}
.subsector {
  background: url("../../assets/bg-lightblue-bar.png") 0 0 repeat-x;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 5px;
}
.content {
  padding-top: 30px;
  padding-left: 50px;
  padding-right: 50px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 0;
}
.keypoints {
  border-left-style: solid;
  border-left-width: 5px;
  border-left-color: #b8da66;
  margin-left: 2rem;
}
.keypoints h3 {
  text-transform: uppercase;
  text-align: left;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #333;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.keypoints ul {
  margin-left: 1.5rem;
}
.keypoints li {
  display: list-item;
  list-style-type: disc;
  margin-bottom: 0.8rem;
}
img {
  float: right;
  margin-top: 50px;
}
button {
  background-color: #0071bc;
  border-radius: 3px;
  border: 0;
  color: #fff;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  margin-top: 2rem;
  cursor: pointer;
  margin-left: 1rem;
}
.parent-sector {
  position: static;
  color: #012e51;
  z-index: 1;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 10px;
  margin-left: 50px;
}

.center button {
  position: static !important;
}
</style>
